import React from 'react'
import styled from 'styled-components'
import './Dust.css'

const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  position: absolute;
  width: 100%;
  height: 100%;
`

const Cell = styled.div`
  width: 5%;
  background-color: #544745;
  transition: transform 3s ease-out;
  transition-delay: 1s;
`

const Dust = (props) => {
  const squares = Array.from(Array(500), (x, index) => index + 1)
  const randomX = () => Math.floor(Math.random() * 250)
  const randomY = () => Math.floor(Math.random() * 150) - 150

  const dusted = props.dusted
  const toDust = props.toDust

  const boxStyles = {
    visibility: dusted ? 'visible' : 'hidden',
    animation: dusted ? 'goodbye 4s forwards' : null
  }

  if (toDust) {
    return (
      <Box style={boxStyles}>
        { squares.map((index) => {
          const cellStyles = {
              transform: dusted ? `translate(${randomX()}px, ${randomY()}px)` : `translate(0, 0)`
            }
          return (
          <Cell style={cellStyles} key={index} ></Cell>
        )})
      }
      </Box>
    )
  } else {
    return null
  }
}

export default Dust
